import { render } from "./AdminView.vue?vue&type=template&id=0c3e9be4&scoped=true&ts=true"
import script from "./AdminView.vue?vue&type=script&lang=ts"
export * from "./AdminView.vue?vue&type=script&lang=ts"

import "./AdminView.vue?vue&type=style&index=0&id=0c3e9be4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3e9be4"]])

export default __exports__